import { render, staticRenderFns } from "./VariantList.vue?vue&type=template&id=d2fd5738&"
import script from "./VariantList.vue?vue&type=script&lang=js&"
export * from "./VariantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports